import { StatusToneEnum } from '../base/StatusToneEnum'

export enum TaskStatusEnum {
  Draft = 'Draft',
  InProgress = 'In Progress',
  Complete = 'Complete',
  Cancelled = 'Cancelled',
}

export const TaskStatus = {
  Draft: {
    value: TaskStatusEnum.Draft,
    description: 'The task have not started yet',
    sort: 0,
    tone: StatusToneEnum.Draft,
  },
  InProgress: {
    value: TaskStatusEnum.InProgress,
    description: 'The task has started',
    sort: 1,
    tone: StatusToneEnum.InProgress,
  },
  Complete: {
    value: TaskStatusEnum.Complete,
    description: 'The task is done.',
    sort: 2,
    tone: StatusToneEnum.Active,
  },
  Cancelled: {
    value: TaskStatusEnum.Cancelled,
    description: 'The task has been cancelled.',
    sort: 3,
    tone: StatusToneEnum.Cancelled,
  },
}
